import React from 'react'

import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import formatCurrency from 'utils/formatAmount'

const useStyles = makeStyles({
  field: {
    textAlign: 'right',
  },
})

export const CurrencyField = ({ basePath, ...props }) => {
  const classes = useStyles()

  const value = props.record[props.source]

  const valueFormatted = typeof value !== 'number' ? +value : value

  return (
    <div className={classes.field}>
      <Typography variant="body2" className={props.className}>
        {formatCurrency.format(valueFormatted)}
      </Typography>
    </div>
  )
}
